import { Activity, Fingerprint, Stethoscope, Home } from "lucide-react";

const benefits = [
  {
    icon: Activity,
    title: "Metabolic health support",
    description: "Evidence-based protocols that may help reduce metabolic risk factors when paired with lifestyle changes.",
  },
  {
    icon: Fingerprint,
    title: "Personalized treatment protocols",
    description: "Care plans tailored to your biology, goals, and medical history by your treating physician.",
  },
  {
    icon: Stethoscope,
    title: "Continuous physician-guided care",
    description: "Ongoing monitoring and adjustments by independently licensed clinicians.",
  },
  {
    icon: Home,
    title: "At-home telehealth visits",
    description: "Connect with your provider from home, where allowed by state law.",
  },
];

const BenefitsSection = () => {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-champagne mb-3">
            Why It Works
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-foreground mb-4">
            Designed around evidence-based optimization.
          </h2>
          <p className="text-muted-foreground">
            Physician-guided care focused on early risk identification and personalized support — never guarantees of outcomes.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="p-6 rounded-2xl bg-card border border-border hover:border-primary/30 transition-colors text-center space-y-4"
            >
              <div className="w-12 h-12 mx-auto rounded-xl bg-primary/10 flex items-center justify-center">
                <b.icon size={22} className="text-primary" />
              </div>
              <h3 className="font-display text-lg text-foreground">{b.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
